/* eslint-disable default-case */
import React, { useState, useEffect } from 'react';
import {
   Table, Space, Button, Select, Input, Tag, DatePicker
} from 'antd';
import * as AntDIcons from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
// import SideCalendar from '../../components/side-calendar/SideCalendar';
// import NoticeBoard from '../../components/notice-board/NoticeBoard';
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import moment from 'moment';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import './Attendance.css';

const { Option } = Select;

const { RangePicker } = DatePicker;

export function Attendance() {
   const navigate = useNavigate();

   const [searchText, setSearchText] = React.useState("");
   const [searchedColumn, setSearchedColumn] = React.useState("");

   const [sectionLoading, setSectionLoading] = useState(false);
   const [level, setLevel] = useState(null);
   const [section, setSection] = useState([]);
   const [sectionList, setSectionList] = useState([]);
   const [listLoading, setListLoading] = useState(false);
   const [levelList, setLevelList] = useState([]);

   const [attendanceList, setAttendanceList] = useState([]);
   const [dateRange, setDateRange] = useState({
      start_date: null,
      end_date: null,
   });
   const [studentsLoading, setStudentsLoading] = useState(false);
   const [studentList, setStudentList] = useState([]);
   const [selectedStudent, setSelectedStudent] = useState(null);

   const subdomain = localStorage.getItem("lms-subdomain");
   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

   const dateFormat = 'MMM D, YYYY';
   const customFormat = value => `${value.format(dateFormat)}`;

   useEffect(() => {
      Utils.verifyJwt();

      // if (user_role.toLowerCase() !== 'admin' && user_role.toLowerCase() !== 'teacher')
      //    navigate('/home');

      if (user_role !== 'Student')
         getLevels();
      else
         setSelectedStudent(user_id);
   }, []);

   const getLevels = () => {
      axios.get(`${process.env.REACT_APP_API_LOOKUP}/levellist`).then((response) => {
         if (response.data) {
            const data = response.data;
            let levels = [];

            data.map((item) => {
               let obj = { 'value': item.value, 'name': item.name }
               levels.push(obj);
            });

            setLevelList(levels);
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = clearFilters => {
      clearFilters();
      setSearchText("");
   };

   const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
                  //this.searchInput(node);
               }}
               placeholder={`Search ${dataIndex}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<AntDIcons.SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}>
                  Search
               </Button>
               <Button
                  size="small"
                  style={{ width: 90 }}
                  // onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}
                  onClick={() => {
                     handleReset(clearFilters);
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Reset
               </Button>
            </Space>
         </div>
      ),
      filterIcon: filtered => <AntDIcons.SearchOutlined style={{ color: filtered ? '#033D89' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
      // onFilterDropdownVisibleChange: visible => {
      //    if (visible) {
      //       setTimeout(() => this.searchInput.select(), 100);
      //    }
      // },
      render: text =>
         searchedColumn === dataIndex ? (
            <Highlighter
               highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
               searchWords={[searchText]}
               autoEscape
               textToHighlight={text ? text.toString() : ''}
            />
         ) : (
            text
         ),
   });

   const AttendanceListColumns = [
      {
         title: '',
         dataIndex: 'attendance_id',
         key: 'attendance_id',
         hidden: true,
      },
      // {
      //    title: 'Student Name',
      //    key: 'person_name',
      //    dataIndex: 'person_name',
      //    sorter: (a, b) => { return a.last_name.localeCompare(b.last_name) },
      //    ...getColumnSearchProps('title'),
      //    ellipsis: {
      //       showTitle: false,
      //    },
      //    // render: person_name => (
      //    //    <Tooltip placement="right" title={person_name}>
      //    //       <span style={{ cursor: "default" }}>
      //    //          {person_name !== null ? person_name.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) : ''}
      //    //       </span>
      //    //    </Tooltip>
      //    // ),
      //    width: '30%'
      // },
      {
         title: 'Date',
         key: 'attendance_date',
         dataIndex: 'attendance_date',
         width: '10%'
      },
      {
         title: 'Day',
         key: 'day_name',
         dataIndex: 'day_name',
         width: '10%'
      },
      {
         title: 'Time In',
         key: 'time_in',
         dataIndex: 'time_in',
         width: '15%'
      },
      {
         title: 'Time Out',
         key: 'time_out',
         dataIndex: 'time_out',
         width: '15%'
      },
      {
         title: 'Status',
         key: 'status',
         sorter: (a, b) => { return a.status.localeCompare(b.status) },
         ...getColumnSearchProps('status'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (

            object.status !== null
               ?
               <Tag
                  style={{ fontSize: 12, cursor: 'default' }}
                  color={object.status === 'PRESENT' ? 'green' : (object.status === 'LATE' ? 'gold' : 'red')}
               >
                  {object.status}
               </Tag>
               :
               ''

         ),
         width: '20%'
      },
      // {
      //    title: 'Status',
      //    key: 'status',
      //    dataIndex: 'status',
      //    width: '20%'
      // },

   ].filter(item => !item.hidden);

   const handleLevelChange = (val) => {
      setSection(null);
      setSelectedStudent(null);
      setSectionList([]);
      setStudentList([]);
      setLevel(val);
      setSectionLoading(true);

      axios.get(`${process.env.REACT_APP_API_LOOKUP}/sectionlistbylevel?level=${val}`).then((response) => {
         if (response.data) {
            const data = response.data;

            // var sectionlist = [];
            // data.map((item) => {
            //    let obj = { 'value': item.value, 'name': item.name }
            //    sectionlist.push(obj);
            // });

            setSectionList(data);
            setSectionLoading(false);
         }
      }, (error) => {
         setSectionLoading(false);
         console.log(error.message);
      });
   }

   const handleSectionChange = (val) => {
      setSelectedStudent(null);
      setStudentList([]);
      setStudentsLoading(true);
      setSection(val);

      axios.get(`${process.env.REACT_APP_API_LOOKUP}/studentlist?level=${level}&section=${val}`).then((response) => {
         if (response.data) {
            const data = response.data;
            setStudentList(data);
            setStudentsLoading(false);
         }
      }, (error) => {
         setStudentsLoading(false);
         console.log(error.message);
      });
   }

   const handleSearchAttendance = () => {
      setListLoading(true);

      let userType = user_role === 'Student' ? 'student' : 'staff';

      var url = `${process.env.REACT_APP_API_SCHOOL_MANAGEMENT}/getattendance?person_id=${selectedStudent}&type=${userType}&startdate=${dateRange.start_date}&enddate=${dateRange.end_date}`;
      axios.get(url).then((response) => {
         if (response.data) {
            const data = response.data;

            //-- Create list based on selected date range
            var d1 = new Date(dateRange.start_date);
            var d2 = new Date(dateRange.end_date);

            var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            var attendanceData = [];

            for (var d = d1; d <= d2; d.setDate(d.getDate() + 1)) {
               var day_name = days[d.getDay()];
               var tmpAttendanceData = {
                  attendance_date: moment(d).format("MMM. DD, YYYY"),
                  day_name,
                  time_in: null,
                  time_out: null,
                  status: day_name !== 'Saturday' && day_name !== 'Sunday' ? 'ABSENT' : null,
               }

               for (var i = 0; i < data.length; i++) {
                  var attDate = moment(new Date(data[i].attendance_date)).format("MMM. DD, YYYY");
                  var curDate = moment(d).format("MMM. DD, YYYY");
                  if (attDate === curDate) {
                     tmpAttendanceData.time_in = data[i].time_in;
                     tmpAttendanceData.time_out = data[i].time_out;
                     tmpAttendanceData.status = data[i].status;
                     break;
                  }
               }

               attendanceData.push(tmpAttendanceData);
            }

            setAttendanceList(attendanceData);
            setListLoading(false);
         }
      }, (error) => {
         setListLoading(false);
         console.log(error.message);
      });
   }

   const onDateTimeChange = (value, dateString) => {
      console.log('Selected Time: ', value);
      console.log('Formatted Selected Time: ', dateString);
      setDateRange({
         start_date: moment(dateString[0]).format("YYYY-MM-DD"),
         end_date: moment(dateString[1]).format("YYYY-MM-DD")
      });
   }

   const disabledDate = (current) => {
      // Can not select days before today and today
      return current && current > moment().endOf('day');
   };

   return (
      <>
         <div className="dashboard-area-all attendance-page">
            <div className="dashboard-item attendance-shell">
               <div className="attendance-breadcrumb">
                  {/* <ul>
                     <li><a href="#" onClick={() => navigate('/home')}>Home</a></li>
                     <li><span>/</span></li>
                     <li><a className="active">Attendance</a></li>
                  </ul> */}
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'attendance', node: 'Attendance' },
                        { key: 'gate', node: 'Gate' },
                     ]}
                  />
               </div>
               <section className="attendance-overview">
                  <span className="attendance-kicker">Attendance</span>
                  <h1>Gate Attendance</h1>
                  <p>Review gate attendance records across a selected date range.</p>
                  <div className="attendance-meta">
                     <span><AntDIcons.TeamOutlined /> {user_role}</span>
                     <span><AntDIcons.CalendarOutlined /> {listLoading ? 'Loading records' : `${attendanceList.length} record${attendanceList.length === 1 ? '' : 's'}`}</span>
                  </div>
               </section>

               <section className="attendance-panel">
                  <div className="attendance-panel-header">
                     <div>
                        <span className="attendance-kicker">Filters</span>
                        <h2>{!['Student', 'Parent'].includes(user_role) ? 'Choose Learner & Date Range' : 'Date Range'}</h2>
                     </div>
                  </div>
                  <div className={!['Student', 'Parent'].includes(user_role) ? "attendance-filter-grid attendance-filter-grid-5" : "attendance-filter-grid attendance-filter-grid-2"}>
                     {
                        !['Student', 'Parent'].includes(user_role) &&
                        <>
                           <Select
                              showArrow
                              size='middle'
                              style={{ width: '100%' }}
                              allowClear
                              placeholder="Select Level"
                              onChange={(val) => handleLevelChange(val)}
                              value={level}
                           >
                              {levelList.map(({ value, name }, idx) => {
                                 return <Option value={value}>{name}</Option>
                              })}
                           </Select>
                           <Select
                              loading={sectionLoading}
                              showArrow
                              size='middle'
                              style={{ width: '100%' }}
                              allowClear
                              placeholder="Select Section"
                              value={section}
                              onChange={(val) => handleSectionChange(val)}
                           >
                              {sectionList.map(({ value, name }, idx) => {
                                 return <Option value={value}>{name}</Option>
                              })}
                           </Select>
                           <Select
                              loading={listLoading}
                              showArrow
                              size='middle'
                              style={{ width: '100%' }}
                              allowClear
                              placeholder="Select Student"
                              value={selectedStudent}
                              onChange={(val) => setSelectedStudent(val)}
                           >
                              {studentList.map(({ value, name }, idx) => {
                                 return <Option value={value}>{name}</Option>
                              })}
                           </Select>
                        </>
                     }
                     <RangePicker
                        style={{ width: "100%" }}
                        format={customFormat}
                        onChange={onDateTimeChange}
                        disabledDate={disabledDate}
                     />

                     <Button className='button-shadow' type='primary' shape='round' onClick={() => handleSearchAttendance()} icon={<AntDIcons.SearchOutlined />}>Search</Button>
                  </div>

               </section>

               <section className="attendance-panel">
                  <div className="attendance-panel-header">
                     <div>
                        <span className="attendance-kicker">Records</span>
                        <h2>Attendance List</h2>
                     </div>
                     <div className="attendance-meta" style={{ marginTop: 0 }}>
                        <span>{listLoading ? 'Loading records' : `Total Records: ${attendanceList.length}`}</span>
                     </div>
                  </div>
                  <div className="attendance-table-shell">
                     <Table
                        rowKey={'uid'}
                        loading={listLoading}
                        size='small'
                        columns={AttendanceListColumns}
                        dataSource={attendanceList}
                        pagination={false}
                        scroll={{
                           x: '1000px',
                           y: 'calc(100svh - 25rem)',
                        }}
                        footer={() => 'Total Records: ' + attendanceList.length}
                     />
                  </div>
               </section>
            </div>
         </div>
         {/* <div className="notice-area">
            <div className="notice-item">
               <SideCalendar />
               <NoticeBoard />
            </div>
         </div> */}
      </>
   );
}

